import api from '@/services/api';
import { userConsentObservation } from '@/helpers/ConsentHelpers';
import store from '@/store';

export default {
  async sauvegarderPreferenceJoueRecemment(cleProduit) {
    // https://lotoquebec.atlassian.net/browse/NAVCAT-564
    // listeJoueRecemment: Array de Array de uuid/dataHeure
    // Ex: [[uuid,dateHeure],...]
    await sauvegarderPreference('recents', cleProduit);
  },
  async sauvegarderPreferenceFavori(cleProduit) {
    // https://lotoquebec.atlassian.net/browse/NAVCAT-565
    // listeFavori: Array de Array de uuid/dataHeure
    // Ex: [[uuid,dateHeure],...]
    await sauvegarderPreference('favoris', cleProduit);
  },
  async supprimerPreferenceFavori(cleProduit) {
    await supprimerPreference('favoris', cleProduit);
  },
};
async function sauvegarderPreference(propriete, valeur) {
  userConsentObservation(process.env.VUE_APP_IAB_ID_PREFERENCE, function () {
    api
      .call(
        `ce-intpref/v2/players/preferences/${propriete}/${valeur}`,
        'playersPreferences',
        'POST',
        {
          withCredentials: true,
          nePasFermerSessionSiErrorConnexion: true,
        }
      )
      .then((response) => {
        /**
         * Si réussite (HttpStatus == 201) sauvegarde preferences
         * On affiche un log dans la console du navigateur
         * Pour tout autre statut (200 / 400 / 401 / 404 / 500) : permettre au client de continuer
         * sans afficher aucun message erreur/informatif
         * */
        // if (response.status === 201 && propriete === 'favoris') {
        // store.commit('preferences/SET_PREFERENCE_FAVORI', response.data);
        /* } else */ if (response.status === 201 && propriete === 'recents') {
          store.commit('preferences/SET_PREFERENCE_JOUE_RECEMMENT', response.data);
        }
      })
      .catch((error) => {
        console.warn(`Échec à la sauvegarde des préférences(${propriete}) : ${valeur}`, error);
      });
  });
}

async function supprimerPreference(propriete, valeur) {
  userConsentObservation(process.env.VUE_APP_IAB_ID_PREFERENCE, function () {
    api
      .call(
        `ce-intpref/v2/players/preferences/${propriete}/${valeur}`,
        'playersPreferences',
        'DELETE',
        {
          withCredentials: true,
          nePasFermerSessionSiErrorConnexion: true,
        }
      )
      .then((response) => {
        /**
         * Si réussite (HttpStatus == 204) supprime preferences
         * On affiche un log dans la console du navigateur
         * Pour tout autre statut (200 / 400 / 401 / 404 / 500) : permettre au client de continuer
         * sans afficher aucun message erreur/informatif
         * */
        if (response.status === 204) {
          console.debug(`Suppression de la préférence(${propriete}) du profil: ${valeur}`);
          // store.commit('preferences/DEL_PREFERENCE_FAVORI', valeur);
        }
      })
      .catch((error) => {
        console.warn(`Échec de la supression de la préférence(${propriete}) : ${valeur}`, error);
      });
  });
}
